module.exports = __webpack_public_path__ + "json/market10-0.json?b5c91f674cb516a0d76759600589bc1d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market10-0.json
// module id = 1253
// module chunks = 3